import { Form, Formik } from 'formik';
import React, { ReactNode } from 'react';
import * as Yup from 'yup';
import toast from 'react-hot-toast';
import { TFormikValues } from '../types';
import { useTakeABreak } from '../Services/Hooks.TakeABreak';
import { getStrings } from '@/helpers/utils';

type TFormikHOC = {
  children: ReactNode;
};

export default function FormikHOC({ children }: TFormikHOC) {
  const [
    {
      Account: {
        TakeABreak: { errorToast, validationErrorMessage },
      },
    },
  ] = getStrings();

  const [mutate] = useTakeABreak();

  return (
    <Formik<TFormikValues>
      initialValues={{
        period: 0,
        confirmedImmediate: false,
        confirmedUndone: false,
        confirmedPending: false,
      }}
      validateOnChange={false}
      validationSchema={Yup.object().shape({
        period: Yup.number().min(1, validationErrorMessage),
        confirmedImmediate: Yup.boolean().isTrue(validationErrorMessage),
        confirmedUndone: Yup.boolean().isTrue(validationErrorMessage),
        confirmedPending: Yup.boolean().isTrue(validationErrorMessage),
      })}
      onSubmit={async (val, { setSubmitting }) => {
        try {
          setSubmitting(true);
          await mutate(val);
        } catch (e) {
          toast.error(errorToast);
        }
      }}
    >
      <Form>{children}</Form>
    </Formik>
  );
}
